import { useRequest } from "~/api/Request"
import API from "~/api/api"
import API_V2 from "~/api/api-v2"
import { Summary, AgentSummary } from "~/model/Summary"

export function useSummary() {
  const { Request } = useRequest()

  const getSummaryData = async () => {
    const res = await Request.get<Summary>(API.SUMMARY)
    return res
  }

  const getAgentSummaryData = async () => {
    const res = Request.get<AgentSummary>(API.SUMMARY_AGENT)
    return res
  }

  return {
    getSummaryData,
    getAgentSummaryData,
  }
}
